import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSearchData = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_325_78",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 24,
		height: 24,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "#D9D9D9"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_325_78)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M20.875 22.275L18.45 19.875C18.1167 20.1083 17.7457 20.2833 17.337 20.4C16.929 20.5167 16.5083 20.575 16.075 20.575C14.825 20.575 13.7627 20.1373 12.888 19.262C12.0127 18.3873 11.575 17.325 11.575 16.075C11.575 14.825 12.0127 13.7623 12.888 12.887C13.7627 12.0123 14.825 11.575 16.075 11.575C17.325 11.575 18.3877 12.0123 19.263 12.887C20.1377 13.7623 20.575 14.825 20.575 16.075C20.575 16.5083 20.5167 16.929 20.4 17.337C20.2833 17.7457 20.1083 18.125 19.875 18.475L22.275 20.875C22.475 21.075 22.5793 21.3083 22.588 21.575C22.596 21.8417 22.5 22.075 22.3 22.275C22.1 22.475 21.8623 22.575 21.587 22.575C21.3123 22.575 21.075 22.475 20.875 22.275ZM16.075 18.575C16.775 18.575 17.3667 18.3333 17.85 17.85C18.3333 17.3667 18.575 16.775 18.575 16.075C18.575 15.375 18.3333 14.7833 17.85 14.3C17.3667 13.8167 16.775 13.575 16.075 13.575C15.375 13.575 14.7833 13.8167 14.3 14.3C13.8167 14.7833 13.575 15.375 13.575 16.075C13.575 16.775 13.8167 17.3667 14.3 17.85C14.7833 18.3333 15.375 18.575 16.075 18.575ZM1.75 17.55C1.53333 17.4 1.40433 17.196 1.363 16.938C1.321 16.6793 1.36667 16.4333 1.5 16.2L5.275 10.15C5.45833 9.86667 5.71267 9.71267 6.038 9.688C6.36267 9.66267 6.64167 9.775 6.875 10.025L9 12.5L12.175 7.325C12.3583 7.00833 12.6377 6.85 13.013 6.85C13.3877 6.85 13.675 7 13.875 7.3L15.725 10.075C15.3417 10.0917 14.979 10.1373 14.637 10.212C14.2957 10.2873 13.9583 10.3917 13.625 10.525L13.075 9.7L10 14.7C9.81667 14.9833 9.55833 15.1417 9.225 15.175C8.89167 15.2083 8.60833 15.0917 8.375 14.825L6.25 12.35L3.2 17.275C3.05 17.525 2.82933 17.679 2.538 17.737C2.246 17.7957 1.98333 17.7333 1.75 17.55ZM18.3 10.575C17.9833 10.4417 17.654 10.3333 17.312 10.25C16.9707 10.1667 16.6167 10.1167 16.25 10.1L20.8 2.9C20.95 2.66667 21.1667 2.51667 21.45 2.45C21.7333 2.38333 21.9917 2.44167 22.225 2.625C22.4417 2.775 22.575 2.979 22.625 3.237C22.675 3.49567 22.6333 3.74167 22.5 3.975L18.3 10.575Z",
			fill: "currentColor"
		})
	})]
});
export default SvgSearchData;
